
import { useState } from 'react';
import TitleService from 'title-service';
import './SeasonDropDown.scss';
import { OutsideAlerter } from './utility';
export default function SeasonDropDown(props: any) {
    const [open, setOpen] = useState(false);
    let name = '';
    if (props?.seasons) {
        let selectedseason = props?.seasons[props.selectedIndex || 0]
        if (selectedseason) {
            name = selectedseason.name;
        }
    }
    return (
        <OutsideAlerter handler={() => {
            setOpen(false);
        }}>
            <div className="episodeSelector-dropdown thisone">
                <div className="ltr-rqgsqp">
                    <button aria-expanded={`${open}`} onClick={() => {
                        setOpen(true);
                    }} aria-haspopup="true" aria-label="dropdown-menu-trigger-button" className="dropdown-toggle ltr-16khy1u" data-uia="dropdown-toggle">{name}</button>
                    {open && <ul data-uia="dropdown-menu" role="menu" className="ltr-dosjml">
                        {props?.seasons?.map((season, index: number) => {
                            console.log(season);
                            return <li data-index={index} key={`${index}=seaspm`}
                                onClick={() => {
                                    props.setSelected(index);
                                    setOpen(false);
                                }}
                                data-uia="dropdown-menu-item" role="menuitem" tabIndex={0} className="ltr-bbkt7g">
                                <div className="episodeSelector--option">{season.name}<span className="episodeSelector--option-label-numEpisodes">({season?.media?.length || 0}&nbsp;{TitleService(season?.media?.length > 1 ? 'episodes' : 'episode')})</span>
                                </div>
                            </li>
                        })}
                        {/* <div className="ltr-1d90crw">
                        </div>
                        <li data-index="2" data-uia="dropdown-menu-item" role="menuitem" tabIndex={0} className="ltr-bbkt7g">Voir tous les épisodes</li> */}
                    </ul>}
                </div>
            </div>
        </OutsideAlerter>
    );
}